import { useEffect, useMemo, useState } from 'react';
import { Company24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from "./BusinessSwitcherLogo.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getBussinessLogoTID = parentTestId => getTestIds(parentTestId);
export const BusinessSwitcherLogo = _ref => {
  let {
    testId,
    src
  } = _ref;
  const {
    BussinessLogoTID
  } = useMemo(() => getBussinessLogoTID(testId), [testId]);
  const [loadingImage, setLoadingImage] = useState(true);
  const [imageError, setImageError] = useState(false);
  useEffect(() => {
    setLoadingImage(true);
    setImageError(false);
  }, [src]);
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": BussinessLogoTID.Root(),
    children: [(loadingImage || imageError) && /*#__PURE__*/_jsx("div", {
      className: styles.image,
      "data-testid": BussinessLogoTID.NoLogoImage(),
      children: /*#__PURE__*/_jsx(Company24, {})
    }), !imageError && /*#__PURE__*/_jsx("img", {
      src: src || '',
      "data-testid": BussinessLogoTID.LogoImage(),
      className: styles.image,
      onLoad: () => {
        setLoadingImage(false);
      },
      onError: () => {
        setLoadingImage(false);
        setImageError(true);
      }
    })]
  });
};